import { FC } from "react";
import { ButtonBackBox, ButtonBox, ButtonContainer } from "../Button.styled";
import { ButtonContent } from "./ButtonContent";
import { Props } from "./definition";



export const ButtonType1: FC<Props> = ({
  isHideArrow,
  title,
  isShowBack,
  titleConfig,
  onNext,
  onPrev,
  isDisabled
}) => {  
  return (
    <ButtonContainer>
      {isShowBack && (
        <ButtonBackBox onClick={onPrev}>
          <ButtonContent isHideArrow={false} />
        </ButtonBackBox>
      )}
      <ButtonBox type="button" onClick={onNext} disabled={isDisabled}>
        <ButtonContent
          isHideArrow={isHideArrow}
          title={title}
          titleConfig={titleConfig}
        />
      </ButtonBox>
    </ButtonContainer>
  );
};
